import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCGlitzi extends NPC {
    constructor() {
        super(definitions.NPC_ID.GLITZI);

        this.collisionRadius = 20;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_glitzi_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.7, new PIXI.Point(5, -5));
        this.animateIdle(0.5);
    }
}